import { render, staticRenderFns } from "./JudgeDetail.vue?vue&type=template&id=40369def&scoped=true"
import script from "./JudgeDetail.vue?vue&type=script&lang=js"
export * from "./JudgeDetail.vue?vue&type=script&lang=js"
import style0 from "./JudgeDetail.vue?vue&type=style&index=0&id=40369def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40369def",
  null
  
)

export default component.exports